/*
Modulo para filtrar articulos/regalos utilizado apartir de variables para modificar tamaños y vistas del componente
ir al pie de pagina, Proptypes

Values = filtre = {
    name: "",
    family: "",
    idCenter: user.idCenter,
    points: [user.points + 1, 100000] //[0]Desde [1]hasta
  }
*/

import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'

// SERVICE
import ServiceCenter from '../services/Center'
import ServiceGift from '../services/Gift'

// COMPONENT
import RangeSlider from '../components/RangeSlider'
import ScanCode from '../components/ScanCode'

// #region CSS
import { makeStyles } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import ExpansionPanel from '@material-ui/core/ExpansionPanel'
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary'
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails'
import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'
import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import Select from '@material-ui/core/Select'
import InputAdornment from '@material-ui/core/InputAdornment'
import IconButton from '@material-ui/core/IconButton'
import ListSubheader from '@material-ui/core/ListSubheader'
import MenuItem from '@material-ui/core/MenuItem'
import Typography from '@material-ui/core/Typography'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import PhotoCamera from '@material-ui/icons/PhotoCamera'
import PhotoCameraOutlinedIcon from '@material-ui/icons/PhotoCameraOutlined'
import ClearIcon from '@material-ui/icons/Clear'
const useStyles = makeStyles(theme => ({
  btn_camera: {
    marginLeft: '5px',
    marginTop: '5px',
    height: '56px'
  },
  input: {
    backgroundColor: '#ffffff',
    fontSize: 18,
    textAlign: 'right',
    paddingRight: 15
  }
}))
// #endregion

export default function FilterItem({
  filter,
  setFilter,
  token,
  options
}) {
  const classes = useStyles()
  // #region Values & Const
  const [powerCodeScan, setPowerCodeScan] = useState(options.powerOff)
  const [values, setValues] = useState(filter)
  const [listFamily, setListFamily] = useState([])
  const [listProvinceCenter, setListProvinceCenter] = useState([])
  const isHorizontal = options ? !!options.isHorizontal : false
  const isMobile = useMediaQuery('(max-width:500px)')
  const [expanded, setExpanded] = useState(!isMobile)
  const isFidelizacion = options ? !!options.isFidelizacion : false
  const isWeb = options ? !!options.isWeb : false
  const isInventario = options ? !!options.isInventario : false
  const haveClient = options ? !!options.haveClient : false
  const haveMovement = options ? !!options.haveMovement : false
  const sizeItemGrid = isHorizontal ? (haveClient || haveMovement) ? 3 : 2 : 12
  // #endregion

  // #region Funtion
  const getListCenter = (token) => {
    return new Promise((resolve, reject) => {
      ServiceCenter.INSTANCE.getListCenter(token)
        .then(listProvince => {
          resolve(listProvince)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
  const getListFamily = (token) => {
    return new Promise((resolve, reject) => {
      ServiceGift.INSTANCE.getListFamily(token)
        .then(listProvince => {
          resolve(listProvince)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  useEffect(() => {
    if (isWeb || isFidelizacion || isInventario) {
      getListFamily(token).then(v => {
        setListFamily(v)
      })
    }

    if (isWeb) {
      getListCenter(token).then(v => {
        let optionsSelect = []
        if (v) {
          v.listProvince.forEach(province => {
            optionsSelect.push(
              <ListSubheader id={province.id} key={province.id} disableSticky={true}>
                {province.name}
              </ListSubheader>
            )
            v.listCenter
              .filter(c => c.idProvince === province.id)
              .forEach(center => {
                optionsSelect.push(
                  <MenuItem id={province.id} key={center.id} value={center.id}>
                    {center.name}
                  </MenuItem>
                )
              })
          })
          setListProvinceCenter(optionsSelect)
        }
      })
    }
    if (isMobile) {
      setExpanded(false)
    }
  }, [isMobile])
  // #endregion

  // #region HandleChange
  const handleChange = prop => event => {
    setValues({ ...values, [prop]: event.target.value })
  }
  const handleChangeBarCode = value => {
    // const copyValues = Object.assign({}, values);
    // copyValues.barCode = value;
    setValues({ ...values, 'barCode': value })
    let newFilter = {
      name: '',
      idCenter: values.idCenter,
      family: '',
      barCode: value,
      points: [0, 100000] // Rango de puntos de un articulo [0] Desde [1] Hasta
    }
    setFilter(newFilter)
  }
  const handleChangePoints = prop => event => {
    if (event.target.value <= 1000000) {
      let copyPoints = Object.assign([], values.points)
      copyPoints[prop] = parseInt(event.target.value)
      setValues({ ...values, points: copyPoints })
    }
  }
  const onChangeSlider = value => { // RangSlider value = [desde, hasta]
    setValues({ ...values, points: value })
  }
  // #endregion

  // #region OnClick
  const onClickFilter = e => {
    e.preventDefault()
    const copyValues = Object.assign({}, values)
    copyValues.barCode = ''
    setFilter(copyValues)
    if (isMobile) {
      setExpanded(false)
    }
  }
  // #endregion

  // #region Displays
  const displayVideoBarCode = (powerCodeScan, width, isLoading) => {
    try {
      if (powerCodeScan) {
        return <Grid container
          direction='row'
          justify='center'
          alignItems='center'
          item
          xs={sizeItemGrid}>
          <ScanCode powerOn={powerCodeScan} powerOff={setPowerCodeScan} setCode={handleChangeBarCode}
            options={
              {
                width: (width - 50) + 'px',
                isLoading
              }
            } />
        </Grid>
      }
    } catch (e) {
      alert(e)
    }
  }
  const displayInputBarCode = () => {
    if (isInventario || isFidelizacion) {
      return <Grid container
        direction='row'
        justify='center'
        alignItems='center'
        item
        style={{ paddingTop: '0px' }}
        xs={sizeItemGrid}>
        <Grid item xs={!isFidelizacion ? 9 : 12}>
          <TextField
            variant='outlined'
            margin='normal'
            // type="number"
            fullWidth
            id='field_bar_code'
            label={<span data-lang="gift_filter_barcode">Cód. de barras</span>}
            InputProps={{
              classes: { input: classes.input },
              startAdornment: values.barCode !== '' ? (
                <InputAdornment position='start'>
                  <IconButton style={{ padding: '0px' }}
                    onClick={() => { setValues({ ...values, barCode: '' }) }}>
                    <ClearIcon />
                  </IconButton>
                </InputAdornment>
              ) : null
            }}
            value={values.barCode}
            onChange={handleChange('barCode')}
          />
        </Grid>
        {!isFidelizacion ? <Grid item xs={3}>
          <Button
            fullWidth
            variant='contained'
            color='secondary'
            size='large'
            className={classes.btn_camera}
            onClick={() => { setPowerCodeScan(!powerCodeScan); setValues({ ...values, barCode: '' }) }}
            startIcon={powerCodeScan ? <PhotoCameraOutlinedIcon style={{ marginLeft: '15px' }} /> : <PhotoCamera style={{ marginLeft: '15px' }} />}
          />
        </Grid> : null}
      </Grid>
    }
  }
  const displaySelectFamily = () => {
    if (isWeb || isFidelizacion || isInventario) {
      return <Grid item xs={sizeItemGrid}>
        <FormControl variant='outlined' fullWidth>
          <InputLabel id='family-select-outlined-label'>
            <span data-lang="gift_filter_family">Familia</span>
          </InputLabel>
          <Select
            labelId='family-select-outlined-label'
            id='family-select-outlined'
            value={values.family}
            onChange={handleChange('family')}
            labelWidth={65}
          >
            <MenuItem value={0}><span data-lang="gift_filter_no_selection">Sin seleccionar</span></MenuItem>
            {listFamily.map(family => (
              <MenuItem key={family.id} value={family.id}>
                {family.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
    }
  }
  const displaySelectCentros = () => {
    if (isWeb) {
      return <Grid item xs={12}>
        <FormControl variant='outlined' fullWidth>
          <InputLabel id='center-select-outlined-label'>
            <span data-lang="gift_filter_center">Centro</span>
          </InputLabel>
          <Select
            labelId='center-select-outlined-label'
            id='center-select-outlined'
            value={values.idCenter}
            onChange={handleChange('idCenter')}
            labelWidth={70}
            defaultValue={''}
            disabled={true} // {listProvinceCenter.length === 0}
          >
            {listProvinceCenter}
          </Select>
        </FormControl>
      </Grid>
    }
  }
  const displayRangeSlider = () => {
    if (isWeb || isInventario) {
      return <Grid
        item
        xs={sizeItemGrid}
        style={{ paddingTop: '0px' }}
      >
        <FormControl variant='outlined' fullWidth>
          <InputLabel id='demo-simple-slider-outlined-label'>
            <span data-lang="gift_filter_points">Puntos</span>
          </InputLabel>
        </FormControl>
        <Grid
          container
          justify='center'
          alignItems='center'
          item
          xs={12}
        >
          <Grid item xs={11}>
            <RangeSlider
              onChange={onChangeSlider}
              initialState={values.points}
            />
          </Grid>
        </Grid>

      </Grid>
    }
  }
  const displayInputsPoints = () => {
    if (isWeb || isInventario || isFidelizacion) {
      return <Grid
        container
        item
        xs={sizeItemGrid}
        justify='center'
        alignItems='center'
        style={{ paddingTop: '0px' }}
      >
        <Grid item xs={6} style={{ paddingRight: '10px' }}>
          <TextField
            variant='outlined'
            type='number'
            margin='normal'
            InputProps={{ classes: { input: classes.input } }}
            inputProps={{ "data-lang": "gift_filter_points_from_placeholder" }}
            fullWidth
            label={<span data-lang="gift_filter_points_from">Desde</span>}
            placeholder={'0'}
            value={values.points[0]}
            onChange={handleChangePoints(0)}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingLeft: '10px' }}>
          <TextField
            variant='outlined'
            type='number'
            margin='normal'
            InputProps={{ classes: { input: classes.input } }}
            inputProps={{ "data-lang": "gift_filter_points_to_placeholder" }}
            fullWidth
            label={<span data-lang="gift_filter_points_to">Hasta</span>}
            placeholder={'100000'}
            value={values.points[1]}
            onChange={handleChangePoints(1)}
          />
        </Grid>
      </Grid>
    }
  }
  // #endregion

  useEffect(() => {
    setPowerCodeScan(options.powerOff)
  }, [options])

  return (
    <div>
      <Grid container direction='row' justify='center' alignItems='center'>
        <Grid
          item
          xs={11}
          md={12}
          container
          justify='center'
          alignItems='center'
        >
          <form style={{ width: '100%' }}>
            {displayVideoBarCode(powerCodeScan, options.width, options.isLoading)}
            {isInventario ? <Grid item style={{ marginBottom: '5px' }}>{displayInputBarCode()}</Grid> : null}
            <ExpansionPanel expanded={expanded}>
              <ExpansionPanelSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls='panel1a-content'
                id='panel1a-header'
                onClick={() => setExpanded(!expanded)}
              >
                <Typography data-lang="gift_filter_title">Filtros</Typography>
              </ExpansionPanelSummary>
              <ExpansionPanelDetails>
                <Grid
                  container
                  spacing={2}
                  direction='row'
                  justify='center'
                  alignItems='center'
                >
                  <Grid item xs={sizeItemGrid}>
                    <TextField
                      variant='outlined'
                      fullWidth
                      label={<span data-lang="gift_filter_name">Nombre</span>}
                      value={values.name}
                      onChange={handleChange('name')}
                    />
                  </Grid>
                  {isFidelizacion ? displayInputBarCode() : null}
                  {displaySelectFamily()}
                  {displaySelectCentros()}
                  {displayRangeSlider()}
                  {displayInputsPoints()}
                  <Grid item xs={sizeItemGrid}>
                    <Button
                      type='submit'
                      fullWidth
                      variant='contained'
                      color='primary'
                      style={{ color: 'white' }}
                      onClick={onClickFilter}
                      data-lang="filter"
                    >
                      Filtrar
                    </Button>
                  </Grid>
                </Grid>
              </ExpansionPanelDetails>
            </ExpansionPanel>
          </form>
        </Grid>
      </Grid>
    </div>
  )
}

FilterItem.propTypes = {
  filter: PropTypes.object.isRequired, // Objeto con el filtro
  setFilter: PropTypes.func.isRequired, // Funcion para modificar el filtro
  token: PropTypes.string, // Token para realizar las peticiones a la API, con el identificador del usuario
  options: PropTypes.object // Opciones para identificar que displays necesitamos [isHorizontal,isMobile,isFidelizacion,isWeb,isInventario] para diferentes aplicaciones
}

/*
Aplicaciones:
  -Web: [isWeb, isMobile, isHorizontal] si es web mostramos diferentes displays que se modificaran
        apartir de si es visualizado desdel mobil si esta en horizontal o vertial.
  -Fidelización: [isFidelizacion, haveClientes, haveMovements] si es fidelización mostramos diferentes displays que
        se modificaran a partir de si en la pantalla hay movimientos de regalos o de clientes para cambiar los tamaños.
  -Inventario: [isInventario]  si es inventarios mostramos diferentes displays como el escaneador de codigo de barras.
 */
